import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Input,
  Form,
  FormGroup,
  Label,
} from "reactstrap";
import { Accordion, AccordionDetails, Typography } from "@mui/material";
import { Icon } from "@progress/kendo-react-common";
import { useSelector } from "react-redux";
import AdvanceSearch from "../../../CommonComponents/AdvanceSearch";
import TelerikDataTable from "../../../CommonComponents/TelerikDataTable";
import { loadingPanel } from "../../../CommonComponents/CommonFunction";
import useSortedColumns from "../../../utils/useSortedColumns";
import visibleColumns from "./visibleColumns";
import { useAuth } from "oidc-react";
import LeaveReportSummary from "./LeaveSummary/LeaveReportSummary";
import { identity } from "lodash";

// Import the key components from your project

// Define the columns for the Telerik grid and for the search component
const reportColumns = [
  {
    field: "employee_no",
    title: "Employee No.",
    // isSortable: true, // Example property if your component uses it
  },
  {
    field: "employee_name",
    title: "Employee Name",
  },
  {
    field: "DepartmentName",
    title: "Department",
  },
  {
    field: "job_title",
    title: "Job Title",
  },
];

const EmployeeReport = () => {
  const id = "employeeReport";

  const {
    columns,
    loadingSearch,
    searchResults,
    ColumnsSorted,
    searchParameter,
    // searchResults: { results, rowCount },
  } = useSelector((state) => state.advanceSearchv2Reducer);

  const [filterValue, setFilterValue] = useState("");

  const [searchParams, setSearchParams] = useState([]);
  const [additionalWhere, setAdditionalWhere] = useState("");
  const [expandedSearchResult, setexpandedSearchResult] = useState(false);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [sortData, setSortData] = useState([
    { field: "employee_name", dir: "asc" },
  ]);
  const [currentTableName, setCurrentTableName] = useState(
    "vw_EmployeeHRleavereport"
  );
  const [chooseFilterMethod, setChooseFilterMethod] = useState("normalSearch");
  const [toggleSummary, setToggleSummary] = useState(true);

  const [isSearchTriggered, setIsSearchTriggered] = useState(false);

  const { results, rowCount } = useSelector(
    (state) =>
      state.advanceSearchv2Reducer.searchResultsV2?.[id] || {
        results: [],
        rowCount: 0,
      }
  );
  // const columns = useSelector(
  //   (state) => state.advanceSearchv2Reducer.columnsById?.[id] || []
  // );

  // const loadingSearch = useSelector(
  //   (state) => state.advanceSearchv2Reducer.loadingById?.[id] || false
  // );

  // const { ColumnsSorted, searchParameter } = useSelector(
  //   (state) => state.advanceSearchv2Reducer
  // );

  console.log(
    useSelector((state) => state.advanceSearchv2Reducer),
    "searchResultsV2data22211"
  );

  const { userData } = useAuth();

  console.log(userData,'userDataLeaveRep')

  const [sortedColumns, setSortedColumns] = useSortedColumns(
    id,
    ColumnsSorted,
    columns,
    visibleColumns,
    userData
  );

  

  const handleTableNameToggle = () => {
    setCurrentTableName((prevTableName) =>
      prevTableName === "vw_EmployeeHRleavereport"
        ? "vw_EmployeeHRleavereportToggle"
        : "vw_EmployeeHRleavereport"
    );
  };
  const handleSearchClick = () => {
    if (!filterValue.trim()) {
      alert("Please enter an Employee Name or Number to search.");
      return;
    }

    const isEmployeeNumber = /^\d+$/.test(filterValue.trim());
    const searchColumn = isEmployeeNumber ? "employeeid" : "employee_name";

    const searchOperator = isEmployeeNumber ? "=" : "contains";

    const newSearchParams = [
      {
        columnName: searchColumn,
        operator: searchOperator,
        value: filterValue.trim(),
        id: new Date().getTime(),
        dataType: 'bigint',
      },
    ];

    setSearchParams(newSearchParams);
    // setAdditionalWhere(`${searchColumn} = '${filterValue.trim()}'`);
    setPage(1);
    setIsSearchTriggered(true);
  };

  useEffect(() => {
    if (loadingSearch) setexpandedSearchResult(true);
  }, [loadingSearch]);

  const handlePageChange = (event) => {
    setPage(event.page.skip / event.page.take + 1);
    setPageSize(event.page.take);
  };
  const handleSortChange = (sort) => {
    setSortData(sort);
    // setPage(1);
  };
  const handleFilterChange = (data) => {
    setAdditionalWhere(data);
    setPage(1);
  };

  const handlePageSizeChange = (event) => {
    setPageSize(event.target.value);
    setPage(1);
  };

  // useEffect(() => {
  //   if (searchParameter[id]?.searchParams?.length > 0) {
  //     setSearchParams(JSON.parse(searchParameter[id]?.searchParams));
  //   }
  // }, [searchParameter]);

  const pdfHeaderContent = useMemo(() => {
    const allFilters = [];

    try {
      const parsed = searchParams;
      if (Array.isArray(parsed) && parsed.length > 0) {
        parsed.forEach(param => {
          const title = param.columnName.replace(/([A-Z])/g, ' $1').trim();
          allFilters.push(`${title} ${param.operator} "${param.value}"`);
        });
      }
    } catch (e) {
      console.error("Could not parse searchParams for header:", e);
    }

    // if (summaryAdditionalWhere && summaryAdditionalWhere.includes("paycode IN")) {
    //   const match = summaryAdditionalWhere.match(/\(([^)]+)\)/);
    //   if (match && match[1]) {
    //     const codes = match[1].replace(/'/g, "").split(',');
        
    //     const names = leaveNames
    //       .filter(leave => codes.includes(String(leave.paycode)))
    //       .map(leave => leave.paycode_name.trim());

    //     if (names.length > 0) {
    //       allFilters.push(`Leave Type: "${names.join(', ')}"`);
    //     }
    //   }
    // }
    
    if (allFilters.length === 0) {
      return ""; 
    }

    const filtersString = allFilters.join(" &nbsp; | &nbsp; ");
    return `<div style=\\"text-align: center; font-size: 10px;\\"><strong>Filters Applied:</strong> ${filtersString}</div>`;

  }, [searchParams]); 

  if (!userData?.profile?.EMR || userData.profile.EMR !== "YES") {
    return (
      <Container fluid>
        <Row className="justify-content-center align-items-center" style={{ height: "80vh" }}>
          <Col xs="auto">
            <Typography variant="h4" color="textSecondary">
              You are not authorized to access this Page
            </Typography>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <Container fluid={true}>
      <Row className="bg-primary rounded py-3 mb-3">
        <Typography variant="h5">
          <Icon style={{ fontSize: "25px", margin: "10px" }} name="user" />
          Leave Report
        </Typography>
      </Row>
      <Row>
        {loadingSearch && loadingPanel()}

        <Col sm="12" className="page-content">
          <Card>
            <CardBody>
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  handleSearchClick();
                }}
                style={{
                  display: "flex",
                  alignItems: "baseline",
                  gap: "20px",
                  padding: "20px",
                  paddingTop: "40px",
                }}
              >
                <FormGroup
                  style={{ display: "flex", alignItems: "center", gap: "20px" }}
                >
                  <Label for="employeeFilter">
                    <strong>Employee Name or Number</strong>
                  </Label>
                  <Input
                    type="text"
                    id="employeeFilter"
                    value={filterValue}
                    onChange={(e) => setFilterValue(e.target.value)}
                    placeholder="Enter value and click Search..."
                    style={{ width: "300px" }}
                  />
                </FormGroup>
                <Button color="primary" type="submit" disabled={loadingSearch}>
                  <Icon name="search" className="mr-2" />
                  {loadingSearch ? "Searching..." : "Search"}
                </Button>
              </Form>

              {/* <div style={{ display: "none" }}> */}
              {isSearchTriggered &&  (
                <AdvanceSearch
                key={id}
                id={id}
                gridId={id}
                columnLocation="global"
                columnList={"*"}
                columnRefernces={[]}
                tableName={currentTableName}
                searchParams={searchParams}
                forceParams={searchParams}
                additionalWhere={additionalWhere}
                sortData={sortData}
                sortBy={sortData[0].dir}
                orderBy={sortData[0].field}
                pageNumber={page}
                pageSize={pageSize}
                expanded={false}
                location="global"
                chooseFilterMethod={chooseFilterMethod}
              />
              )}
              
              {/* </div> */}

              <hr />

              <div
                className="mb-2"
                style={{
                  display: "flex",
                  flexDirection: "row-reverse",
                  alignItems: "center",
                  gap: "20px",
                }}
              >
                <Button color="primary" onClick={handleTableNameToggle}>
                  Toggle Search
                </Button>
                <Typography variant="caption" className="ms-2">
                  <strong>
                    {currentTableName == "vw_EmployeeHRleavereport"
                      ? "Detailed data"
                      : "Aggregate day data"}
                  </strong>
                </Typography>
              </div>

              {isSearchTriggered && sortedColumns.length > 0 && (
                <Accordion expanded={expandedSearchResult}>
                  <AccordionDetails>
                    <TelerikDataTable
                      id={id}
                      data={results}
                      totalCount={rowCount}
                      pageSize={pageSize}
                      skip={(page - 1) * pageSize}
                      take={pageSize}
                      sortData={sortData}
                      onFilterChange={handleFilterChange}
                      onSortChange={handleSortChange}
                      onPageChange={handlePageChange}
                      onPageSizeChange={handlePageSizeChange}
                      selectedColumns={sortedColumns}
                      setSortedColumns={setSortedColumns}
                      loading={loadingSearch}
                      isPmValidation={false}
                      setChooseFilterMethod={setChooseFilterMethod}
                      chooseFilterMethod={chooseFilterMethod}
                      header={true}
                      headerContent={pdfHeaderContent}
                      headerNameOptional={"LeaveReport"}
                      // isDashboard={true}
                      // header={true}
                    />
                  </AccordionDetails>
                </Accordion>
              )}
              
              <LeaveReportSummary
                key={"leave-report-summary"}
                searchParams={searchParams}
                additionalWhere={""}
                isVisible={results && results.length > 0}
                isSearchTriggered={isSearchTriggered}
                results={results || []}
                header={true}
                headerContent={pdfHeaderContent}
                
              />
              
                
              
              
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default EmployeeReport;
